import React, { useState } from 'react';
import { Box, Tabs, Tab, useTheme, useMediaQuery } from '@mui/material';

const tabLabels = [
  'Payment Integration',
  'Payouts',
  'Integration Guide',
  'API Source',
];

const NavigationTabs = () => {
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box
     sx={{
  width: '100%',
  height: { xs: 80, sm: 90, md: 120 },
  px: { xs: 2, sm: 3 },
  display: 'flex',
  alignItems: 'flex-end',
  position: 'sticky',
  top: 0,
  zIndex: 1100,
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  // 🔽 Two inner shadows (gray top + white bottom)
  boxShadow: `
    inset 0 3px 8px rgba(0, 0, 0, 0.15),  /* gray inner shadow from top */
    inset 0 3px 8px rgba(255, 255, 255, 1.3) /* wider white inner shadow from bottom */
  `,
}}
    >
      <Tabs
        value={activeTab}
        onChange={handleChange}
        variant={isMobile ? 'scrollable' : 'standard'}
        scrollButtons={isMobile ? 'auto' : false}
        TabIndicatorProps={{
          style: {
            backgroundColor: '#10B981',
            height: '4px',
          },
        }}
        sx={{
          width: '100%',
          '& .MuiTabs-flexContainer': {
            justifyContent: 'flex-start', // ✅ left align tabs
          },
          minHeight: 'unset',
        }}
      >
        {tabLabels.map((label, index) => (
          <Tab
            key={label}
            label={label}
            sx={{
              textTransform: 'none',
              fontSize: { xs: '14px', sm: '15px', md: '16px' },
              fontWeight: 500,
              color: activeTab === index ? '#10B981' : '#4B5563',
              minWidth: { xs: 100, sm: 120 },
              px: { xs: 1, sm: 2 },
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default NavigationTabs;
